import React from 'react';
import { Bell, Check, CheckCircle, XCircle, UserPlus, FileText, CurrencyDollar, X } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const ICON_MAP = {
  FileText,
  UserPlus,
  CheckCircle,
  XCircle,
  CurrencyDollar,
  Bell,
};

const COLOR_MAP = {
  blue: 'bg-blue-100 text-blue-600',
  green: 'bg-green-100 text-green-600',
  red: 'bg-red-100 text-red-600',
  emerald: 'bg-emerald-100 text-emerald-600',
  purple: 'bg-purple-100 text-purple-600',
  indigo: 'bg-indigo-100 text-indigo-600',
  slate: 'bg-slate-100 text-slate-600',
};

const timeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  if (seconds < 60) return 'Just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
};

const NotificationItem = ({ notification, onMarkRead, onDelete }) => {
  const IconComponent = ICON_MAP[notification.icon] || Bell;
  const colorClass = COLOR_MAP[notification.color] || COLOR_MAP.slate;

  return (
    <div
      className={`p-3 border-b border-slate-100 hover:bg-slate-50 transition-colors ${
        !notification.read ? 'bg-blue-50/50' : ''
      }`}
      data-testid={`notification-item-${notification.id}`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-full ${colorClass}`}>
          <IconComponent size={16} weight="bold" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-slate-900 truncate">
            {notification.title}
          </p>
          <p className="text-xs text-slate-600 mt-0.5">{notification.message}</p>
          <p className="text-xs text-slate-400 mt-1">{timeAgo(notification.created_at)}</p>
        </div>
        <div className="flex items-center gap-1">
          {!notification.read && (
            <Button
              variant="ghost"
              size="sm"
              className="h-6 w-6 p-0"
              onClick={(e) => {
                e.stopPropagation();
                onMarkRead(notification.id);
              }}
              title="Mark as read"
              data-testid={`notification-mark-read-${notification.id}`}
            >
              <Check size={14} />
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 text-slate-400 hover:text-red-500"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(notification.id);
            }}
            title="Delete"
            data-testid={`notification-delete-${notification.id}`}
          >
            <X size={14} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
